import { render, staticRenderFns } from "./HistamineModal.vue?vue&type=template&id=01cf4fe8&"
import script from "./HistamineModal.vue?vue&type=script&lang=js&"
export * from "./HistamineModal.vue?vue&type=script&lang=js&"
import style0 from "./HistamineModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports